import React from "react";

function AdminEnquiries() {
  return <div>Admin Enquiries Page</div>;
}

export default AdminEnquiries;
